import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import clientForms from './clientForms';

import ListItemField from '../../../common/components/ListItemField';
import measureForm from './measure/measureForm';
import MeasureRow from './measure/MeasureRow';
import FormWrapper from '../../../common/components/FormWrapper';
import { AppDispatch } from '../../../store';
import type { Client } from '../../../common/types/client';
import settingsSelectors from '../../../settings/settingsSelector';
import { loadAdvisors } from '../../../settings/settingsReducer';

type Props = {
  client: Client;
  updateClient: (client: Client) => void;
  saveClient?: (client: Client) => void;
};

function ClientForm({ client, updateClient, saveClient }: Props) {
  const dispatch: AppDispatch = useDispatch();
  const advisors = useSelector(settingsSelectors.getAdvisors);

  React.useEffect(() => {
    dispatch(loadAdvisors());
  }, []);

  return (
    <Stack px={3} pt={1} pb={2} overflow='auto scroll'>
      <Box component='form' noValidate autoComplete='off' maxWidth='650px'>
        {clientForms(advisors).map((form) => (
          <FormWrapper key={form.key} form={form} item={client} save={saveClient} update={updateClient} />
        ))}
        <ListItemField
          items={client.measures || []}
          headline='Kontakte'
          margin={5}
          itemForm={measureForm}
          renderItemRow={(item, itemForm) => <MeasureRow measure={item} itemForm={itemForm} />}
          handleSave={(value) => {
            if (saveClient !== null && saveClient !== undefined) {
              saveClient({
                ...client,
                measures: value,
              });
            }
          }}
          handleChange={(value) => {
            updateClient({
              ...client,
              measures: value,
            });
          }}
        />
      </Box>
    </Stack>
  );
}

export default ClientForm;
